import { z } from 'zod';
import { permissionKeyEnum } from '../permissions';
import { emailSchema, nameSchema, uuidSchema } from './common';

export const inviteStaffSchema = z.object({
  firstName: nameSchema,
  lastName: nameSchema,
  email: emailSchema,
  roleId: uuidSchema,
});
export type InviteStaffPayload = z.infer<typeof inviteStaffSchema>;

export const updateStaffSchema = z.object({
  roleId: uuidSchema.optional(),
  status: z.enum(['active', 'deactivated']).optional(),
});
export type UpdateStaffPayload = z.infer<typeof updateStaffSchema>;

export const transferOwnershipSchema = z.object({
  toUserId: uuidSchema,
});
export type TransferOwnershipPayload = z.infer<typeof transferOwnershipSchema>;

// Custom roles (docs/02): concept-scoped, catalogue keys only.
export const createCustomRoleSchema = z.object({
  name: z.string().trim().min(2).max(50),
  description: z.string().trim().max(300).nullable().optional(),
  permissionKeys: z.array(permissionKeyEnum).min(1),
});
export type CreateCustomRolePayload = z.infer<typeof createCustomRoleSchema>;

export const updateCustomRoleSchema = createCustomRoleSchema.partial();
export type UpdateCustomRolePayload = z.infer<typeof updateCustomRoleSchema>;
